import { useState, RefObject } from "react";
import { Text } from "@chakra-ui/react";
import { FormHandles } from "@unform/core";
import { v4 as uuid } from 'uuid';

import { Container, Content, ContentData, Buttons } from './styles';

type PhoneData = {
	emp_cod: string;
	id: string;
	numero: string;
	obs: string;
};
type EnderecoData = {
	id: string;
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp: string;
	ponto_ref: string;
	emp_cod: string;
};
type ClienteData = {
	id_cliente?: string;
	avatar_url: string;
	pessoa: string;
	id: string;
	nome: string;
	doc: string;
	rg: string;
	email: string;
	nasc: string;
	comissao: 2; // porcentagem
	sexo: string;
	emp_cod: string;
	enderecos: EnderecoData[],
	telefones: PhoneData[]
};

interface ModalVerifClienteExistsProps {
	onClose: (close: boolean) => void;
	isVisible: boolean;
	verifData: any;
	setCliente: (cli: ClienteData) => void;
	setEnderecos: (enderecos: EnderecoData[]) => void;
	setPhones: (phones: PhoneData[]) => void;
	handleCancel: (is_toast: boolean) => void;
	formRefCliente: RefObject<FormHandles>;
	setTabIndex: (tab: number) => void;
	cliente: ClienteData;
};

const ModalVerifClienteExists: React.FC<ModalVerifClienteExistsProps> = ({
	onClose = () => { },
	isVisible,
	verifData,
	setCliente,
	setEnderecos,
	setPhones,
	handleCancel,
	formRefCliente,
	setTabIndex,
	cliente
}) => {

	const [visible, setVisible] = useState(isVisible);

	function handleOnClose() {
		setVisible(false);
		setTimeout(() => {
			onClose(false);
		}, 300);
	};

	async function handleBloquearS() {
		setCliente(verifData.clie_json);
		setEnderecos(verifData.clie_json.enderecos);
		setPhones(verifData.clie_json.telefones);
		formRefCliente.current?.setData(verifData.clie_json);
		handleOnClose();
	};

	return (
		<Container id="ModalVerifClienteExists">
			<Content className={`${visible ? 'active' : ''}`}>
				<Text fontSize={20} fontWeight={600} p={4}>Verificação de Cliente.</Text>

				<ContentData>
					<Text fontSize={[16, 18]} fontWeight={500} wordBreak="break-word">
						{verifData.mensagem}
					</Text>
					<Text fontSize={[16, 18]} fontWeight={500} py={4}>
						Deseja alterar o cadastro do cliente existente?
					</Text>
				</ContentData>

				<Buttons>
					<button
						type="button"
						className="button-cancel"
						onClick={() => {
							handleOnClose();
							handleCancel(true);
						}}
					>
						Cancelar
					</button>

					{verifData.bloquear === 'A' && (
						<button
							type="button"
							className="button-warning"
							onClick={() => {
								setCliente({ ...cliente, id: uuid() })
								setTabIndex(1);
								handleOnClose();
							}}
						>
							Continuar Cadastro
						</button>
					)}

					<button
						type="submit"
						className="button-save"
						onClick={handleBloquearS}
					>
						Alterar Cadastro
					</button>
				</Buttons>
			</Content>
		</Container>
	)
}

export default ModalVerifClienteExists;